<div class="justify-center px-[60px] py-[30px]" isOpen="true">
    <!-- <ion-content> -->
      <div class="flex flex-col items-center gap-[10px]">
        <ark-lib-icon-name name="success"></ark-lib-icon-name>
        <div>
          <h3 class="text-center">Thank you for sharing with the community!</h3>
        </div>
      </div>
    <!-- </ion-content> -->
</div>